module.exports = __webpack_public_path__ + "assets/d02a5ff1021f6ddc3e9ed61149adf563.png";